import { Modal, StyleSheet, Text, View, type GestureResponderEvent } from 'react-native';
import { Divider } from 'react-native-paper';
import { PrimaryButton, SecondaryButton } from 'src/presentation/components/molecules/Button';
import AppUpdateDialogType from 'src/domain/models/AppUpdateDialogType';
import dialogStyles from 'src/presentation/dialogs/styles/DialogStyles';
import type ApiSettings from 'src/core/models/api/ApiSettings';
import Colors from 'src/core/utils/Colors';
import Fonts from 'src/core/utils/Fonts';
import Dimens from 'src/core/utils/Dimens';
import Styles from 'src/core/utils/Styles';
import { useServicesStore } from 'src/domain/stores/useServicesStore';

interface Props {
	apiSettings: ApiSettings;
	onCancelPress: (event: GestureResponderEvent) => void;
	isDialogVisible: boolean;
}

const AppUpdateDialog = ({ apiSettings, onCancelPress, isDialogVisible }: Props) => {
	const { openUrlExternally } = useServicesStore();

	const dialogType = apiSettings.should_mandatory_update_app
		? AppUpdateDialogType.mandatoryUpdateAvailable
		: AppUpdateDialogType.updateAvailable;

	return (
		<Modal animationType="fade" style={dialogStyles.modalView} transparent={true} visible={isDialogVisible}>
			<View style={dialogStyles.centeredView}>
				<View style={dialogStyles.modalCard}>
					<Text style={styles.modalTitle}>{dialogType.dialogTitle}</Text>
					<Divider />
					<View style={{ marginVertical: Dimens.padding12 }} />
					<Text style={styles.label}>{dialogType.dialogDescription}</Text>
					<View style={{ marginVertical: Dimens.padding12 }} />
					<Text style={styles.label}>{dialogType.getDialogVersionDescription(apiSettings)}</Text>
					<View style={{ marginVertical: Dimens.padding12 }} />
					<Divider />
					<View style={Styles.row.dialogButtons}>
						{dialogType.isCancellable && (
							<SecondaryButton
								extraStyle={{ flex: Dimens.flex1 }}
								label={dialogType.cancelButtonTitle}
								onPress={onCancelPress}
							/>
						)}
						<PrimaryButton
							extraStyle={{ flex: Dimens.flex1 }}
							label={dialogType.confirmButtonTitle}
							onPress={() => {
								const storeUrl = dialogType.storeUrl;
								if (storeUrl) {
									openUrlExternally({ url: storeUrl });
								}
							}}
						/>
					</View>
				</View>
			</View>
		</Modal>
	);
};

const styles = StyleSheet.create({
	modalTitle: {
		fontSize: Dimens.fontSize24,
		textAlign: 'center',
		marginBottom: Dimens.padding24,
		fontFamily: Fonts.ptSerif,
	},
	label: {
		color: Colors.black,
		fontSize: Dimens.fontSize17,
		textAlign: 'center',
		fontFamily: Fonts.barlow,
	},
});

export default AppUpdateDialog;
